import { PIN_COLUMN_KEY } from "./constants"
import { TackPinIcon } from "./ReportTableIcons"
import { ReportColumn } from "./types"

export const buildPinColumn = <T extends Record<string, any>>(
  pinnedRowKeys: Set<string>,
  rowKeyResolver: (record: T, index?: number) => string,
  onTogglePinned: (record: T, index?: number) => void
): ReportColumn => ({
  title: "",
  key: PIN_COLUMN_KEY,
  width: 46,
  fixed: "left",
  className: "report-pin-cell",
  render: (_text: unknown, record: T, index: number) => {
    const key = rowKeyResolver(record, index)
    const isPinned = pinnedRowKeys.has(key)
    return (
      <button
        type="button"
        className={`report-pin-button ${
          isPinned ? "report-pin-button-active" : ""
        }`}
        aria-label={isPinned ? "Unpin row" : "Pin row"}
        onClick={(event) => {
          event.stopPropagation()
          onTogglePinned(record, index)
        }}
      >
        <TackPinIcon />
      </button>
    )
  },
})
